// productDetails/selectors/productSelectors.js
export const selectProductData = (state) => state.productDetails.productData;
export const selectLoadingState = (state) => state.productDetails.loading;
export const selectErrorState = (state) => state.productDetails.error;
export const selectProductQuantity = (state) => state.productDetails.productData.quantitySelection.quantity;
export const selectProductWeight = (state) => state.productDetails.productData.quantitySelection.weight;
